var map = {
	"./address_image.svg": "./src/assests/images/address_image.svg",
	"./animated_ashutosh.png": "./src/assests/images/animated_ashutosh.png",
	"./animated_logo.svg": "./src/assests/images/animated_logo.svg",
	"./blogs_image.svg": "./src/assests/images/blogs_image.svg",
	"./cloud_infrastructure.svg": "./src/assests/images/cloud_infrastructure.svg",
	"./codeInLogo.png": "./src/assests/images/codeInLogo.png",
	"./contactMail.png": "./src/assests/images/contactMail.png",
	"./coursera_logo.png": "./src/assests/images/coursera_logo.png",
	"./data_science.svg": "./src/assests/images/data_science.svg",
	"./deeplearning_ai_logo.png": "./src/assests/images/deeplearning_ai_logo.png",
	"./delhivery_logo.png": "./src/assests/images/delhivery_logo.png",
	"./developerActivity.svg": "./src/assests/images/developerActivity.svg",
	"./dsc_logo.png": "./src/assests/images/dsc_logo.png",
	"./education.svg": "./src/assests/images/education.svg",
	"./experience.svg": "./src/assests/images/experience.svg",
	"./feelingProud.svg": "./src/assests/images/feelingProud.svg",
	"./freecopy_logo.png": "./src/assests/images/freecopy_logo.png",
	"./fullstack.svg": "./src/assests/images/fullstack.svg",
	"./gcp_logo.png": "./src/assests/images/gcp_logo.png",
	"./github_logo.png": "./src/assests/images/github_logo.png",
	"./googleAssistant.jpg": "./src/assests/images/googleAssistant.jpg",
	"./googleAssistant.svg": "./src/assests/images/googleAssistant.svg",
	"./google_logo.png": "./src/assests/images/google_logo.png",
	"./ibm_logo.png": "./src/assests/images/ibm_logo.png",
	"./iiitk_logo.png": "./src/assests/images/iiitk_logo.png",
	"./intel_logo.jpg": "./src/assests/images/intel_logo.jpg",
	"./iu_logo.png": "./src/assests/images/iu_logo.png",
	"./jsFramework.svg": "./src/assests/images/jsFramework.svg",
	"./legato_logo.png": "./src/assests/images/legato_logo.png",
	"./manOnTable.svg": "./src/assests/images/manOnTable.svg",
	"./microsoft_logo.png": "./src/assests/images/microsoft_logo.png",
	"./mozilla_logo.png": "./src/assests/images/mozilla_logo.png",
	"./muffito_logo.png": "./src/assests/images/muffito_logo.png",
	"./nextuLogo.jpg": "./src/assests/images/nextuLogo.jpg",
	"./nptel_logo.png": "./src/assests/images/nptel_logo.png",
	"./portfolio.gif": "./src/assests/images/portfolio.gif",
	"./programmer.svg": "./src/assests/images/programmer.svg",
	"./projects_image.svg": "./src/assests/images/projects_image.svg",
	"./pwa.png": "./src/assests/images/pwa.png",
	"./saayaHealthLogo.png": "./src/assests/images/saayaHealthLogo.png",
	"./stanford_logo.png": "./src/assests/images/stanford_logo.png",
	"./talksCardBack.svg": "./src/assests/images/talksCardBack.svg",
	"./talksCardBackAlt.svg": "./src/assests/images/talksCardBackAlt.svg",
	"./tiktok_logo.png": "./src/assests/images/tiktok_logo.png",
	"./ui_ux_design.svg": "./src/assests/images/ui_ux_design.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assests/images sync recursive ^\\.\\/.*$";